// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KwB20","content":"styles_content__eBiYE","tableWrap":"styles_tableWrap__38cXl"};